export default "__VITE_ASSET__BD3P2sPH__"